const getFonts = () => {
  switch (process.env.SOURCE) {
    case 'COMPANY':
      return {
        primary: 'Roboto',
        secondary: 'Roboto',
      };
    default:
      return {
        primary: 'Roboto',
        secondary: 'Roboto',
      };
  }
};

export const fonts = {
  url:
    'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,500;1,400&display=swap',
  ...getFonts(),
};
